import {
  Bell02,
  Code01,
  CreditCard01,
  User03,
  Users01
} from "untitledui-js-base";

export const settingsCards = [
  {
    id: "profile",
    title: "Personal Profile",
    description: "Personal details and how we can reach you",
    icon: User03,
    link: "/settings/profile"
  },
  {
    id: "billing",
    title: "Billing",
    description: "View monthly statements and update your payment method",
    icon: CreditCard01,
    link: "/settings/statements"
  },
  {
    id: "user",
    title: "Users",
    description: "Invite users, set user roles, change permissions",
    icon: Users01,
    link: "/settings/users"
  },
  {
    id: "team",
    title: "Team",
    description: "Team members list and contact information",
    icon: Users01,
    link: "/settings/team"
  },
  {
    id: "developers",
    title: "Developers",
    description:
      "Resources for developers to facilitate seamless integration of software systems",
    icon: Code01,
    link: "/settings/developers"
  },
  {
    id: "notifications",
    title: "Notifications",
    description: "Manage your personal notification preferences",
    icon: Bell02,
    link: "/settings/notifications"
  }
];
